import { SagaIterator } from 'redux-saga';
import { takeLatest, call, put, fork, spawn, FixedTask } from 'typed-redux-saga';
import { NavigationActions } from './actions';
import { navigationService } from 'src/services/navigation';
import { NavigationMenuName } from 'src/enums/navigation/name-menu';
import { callWithRetry } from 'src/utils/call-with-retry';
import { configuration } from 'src/configurations/configuration';

export let loadFooterMenuTask: FixedTask<typeof loadFooterMenu>;
export let loadLeftMenuTask: FixedTask<typeof loadLeftMenu>;
export let loadHomeMenuTask: FixedTask<typeof loadHomeMenu>;

function* loadFooterMenu(): SagaIterator {
  const { maxAttempts, delayMs } = configuration.isrDataFetchRetry;

  try {
    const response = yield* callWithRetry(
      navigationService.getNavigation,
      [NavigationMenuName.FOOTER],
      maxAttempts,
      delayMs
    );

    yield* put(NavigationActions.loadFooterMenuSuccess({ response }));
  } catch (error) {
    yield* put(NavigationActions.loadFooterMenuFailure({ error }));

    throw error;
  }
}

function* loadFooterMenuForServer(): SagaIterator {
  yield* call(function* () {
    loadFooterMenuTask = yield* spawn(loadFooterMenu);
  });
}

function* loadLeftMenu(): SagaIterator {
  try {
    const response = yield* call(navigationService.getNavigation, NavigationMenuName.LEFT);

    yield* put(NavigationActions.loadLeftMenuSuccess({ response }));
  } catch (error) {
    yield* put(NavigationActions.loadLeftMenuFailure({ error }));
  }
}

function* loadLeftMenuForServer(): SagaIterator {
  yield* call(function* () {
    loadLeftMenuTask = yield* fork(loadLeftMenu);
  });
}

function* loadHomeMenu(): SagaIterator {
  const { maxAttempts, delayMs } = configuration.isrDataFetchRetry;

  try {
    const response = yield* callWithRetry(
      navigationService.getNavigation,
      [NavigationMenuName.HOME],
      maxAttempts,
      delayMs
    );

    yield* put(NavigationActions.loadHomeMenuSuccess({ response }));
  } catch (error) {
    yield* put(NavigationActions.loadHomeMenuFailure({ error }));

    throw error;
  }
}

function* loadHomeMenuForServer(): SagaIterator {
  yield* call(function* () {
    loadHomeMenuTask = yield* spawn(loadHomeMenu);
  });
}

export default function* navigationSaga(): SagaIterator {
  yield* takeLatest(NavigationActions.loadLeftMenu, loadLeftMenu);
  yield* takeLatest(NavigationActions.loadLeftMenuForServer, loadLeftMenuForServer);
  yield* takeLatest(NavigationActions.loadHomeMenu, loadHomeMenu);
  yield* takeLatest(NavigationActions.loadHomeMenuForServer, loadHomeMenuForServer);
  yield* takeLatest(NavigationActions.loadFooterMenu, loadFooterMenu);
  yield* takeLatest(NavigationActions.loadFooterMenuForServer, loadFooterMenuForServer);
}
